import { Box, Typography, Button } from '@mui/material';
import { useNavigate } from '@tanstack/react-router';

export const NotFoundPage = () => {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '60vh',
        gap: 2,
        textAlign: 'center',
        p: 4,
      }}
    >
      <Typography
        variant="h1"
        sx={{ fontSize: '6rem', fontWeight: 700, lineHeight: 1 }}
      >
        404
      </Typography>
      <Typography variant="h5" color="text.secondary">
        Page not found
      </Typography>
      <Typography variant="body1" color="text.secondary">
        You don't have permission to access this page.
      </Typography>
      <Button variant="contained" onClick={() => navigate({ to: '/' })}>
        Go Home
      </Button>
    </Box>
  );
};
